import script from "./EditForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditForm.vue?vue&type=script&setup=true&lang=js"

import "./EditForm.vue?vue&type=style&index=0&id=1db3c764&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1db3c764"]])

export default __exports__